// extracted by mini-css-extract-plugin
export var bypassLinks = "layout-module--bypassLinks--ZY4bZ";
export var footer = "layout-module--footer--4XGU7";
export var globalWrapper = "layout-module--globalWrapper--R6-eX";
export var header = "layout-module--header--OVx7L";